"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkArrowWrapper = exports.LinkArrowComponent = exports.FeatureMenuLink = exports.FeatureMenuItem = exports.FeatureMenuButton = void 0;
exports.PrimaryNavTrayMenuItem = PrimaryNavTrayMenuItem;
exports.TrayDropdownBack = exports.TrayDropdown = exports.TrayContent = exports.PrimaryNavTrayPanelLists = exports.PrimaryNavTrayPanelFeatures = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _intentsConfig = _interopRequireDefault(require("../intents.config.js"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _primaryNavTrayPanel = require("./primary-nav-tray-panel");
var _primaryNavTrayFeature = require("../primary-nav-tray-feature");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-len */

const FeatureMenuItem = exports.FeatureMenuItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "FeatureMenuItem",
  class: "pl-f11zqfa5"
});
const FeatureMenuElement = `
  padding: 0;
  cursor: pointer;
  font-size: ${_intentsConfig.default.headerNavigatePrimary.fontSize};
  font-weight: ${_intentsConfig.default.headerNavigatePrimary.fontWeight};
  border: 0;
  margin: 0;
  font-family: ${_intentsConfig.default.ux.textTitle.fontFamily};
  line-height: inherit;
  text-transform: none;
  background: inherit;
  overflow: visible;
  text-align: start;
  position: relative;
  text-decoration: none;
  background: transparent;

  &:focus:not(:focus-visible) {
    outline: none;
  }

  @media screen and ${_patternLibraryUtils.deviceMax.laptop} {
    padding: 0;
    opacity: 1;
    font-size: var(--fixed-space-150);
  }
`;
const FeatureMenuButton = exports.FeatureMenuButton = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "FeatureMenuButton",
  class: "pl-fqpukcf",
  vars: {
    "fqpukcf-1": [({
      isOpen
    }) => isOpen ? `${_intentsConfig.default.ux.navigatePrimaryChosen.backgroundColor}` : 'inherit'],
    "fqpukcf-2": [({
      isOpen
    }) => isOpen ? `${_intentsConfig.default.ux.navigatePrimaryChosen.foregroundColor}` : `${_intentsConfig.default.ux.navigatePrimary.foregroundColor}`],
    "fqpukcf-3": [({
      isOpen
    }) => isOpen ? `${_intentsConfig.default.ux.navigatePrimaryChosen.borderColor}` : 'inherit'],
    "fqpukcf-4": [({
      isOpen
    }) => isOpen ? `${_intentsConfig.default.ux.navigatePrimaryChosen.backgroundColor}` : `${_intentsConfig.default.ux.navigatePrimaryHovered.backgroundColor}`],
    "fqpukcf-5": [({
      isOpen
    }) => isOpen ? `${_intentsConfig.default.ux.navigatePrimaryChosen.foregroundColor}` : `${_intentsConfig.default.ux.navigatePrimaryHovered.foregroundColor}`],
    "fqpukcf-6": [({
      isOpen
    }) => isOpen ? `${_intentsConfig.default.ux.navigatePrimaryChosen.borderColor}` : `${_intentsConfig.default.ux.navigatePrimaryHovered.borderColor}`],
    "fqpukcf-10": [({
      isOpen
    }) => isOpen ? 'scaleX(1)' : 'scaleX(0)']
  }
});
const FeatureMenuLink = exports.FeatureMenuLink = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "FeatureMenuLink",
  class: "pl-f1pf39m"
});
const LinkArrowWrapper = exports.LinkArrowWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "LinkArrowWrapper",
  class: "pl-l39lkgk",
  vars: {
    "l39lkgk-0": [({
      isOpen
    }) => isOpen ? 'none' : 'inline-block']
  }
});
const LinkArrowComponent = exports.LinkArrowComponent = /*#__PURE__*/(0, _react2.styled)(_icon.Icon)({
  name: "LinkArrowComponent",
  class: "pl-l19er40p"
});
const TrayDropdown = exports.TrayDropdown = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayDropdown",
  class: "pl-tccg8n2",
  vars: {
    "tccg8n2-2": [({
      isOpen
    }) => isOpen ? 'scale3d(1, 1, 1) translateZ(0)' : 'scale3d(1, 0, 1)'],
    "tccg8n2-3": [({
      isOpen
    }) => isOpen ? 'visible' : 'hidden'],
    "tccg8n2-6": [({
      isOpen
    }) => isOpen ? 'translateX(0)' : 'translateX(-10%)'],
    "tccg8n2-7": [({
      isOpen
    }) => isOpen ? 'translateX(-1)' : 'translateX(10%)']
  }
});
const TrayDropdownBack = exports.TrayDropdownBack = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayDropdownBack",
  class: "pl-t1adf7a9"
});
const TrayContent = exports.TrayContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayContent",
  class: "pl-t1ob5k59",
  vars: {
    "t1ob5k59-0": [({
      isOpen
    }) => isOpen ? '1' : '0'],
    "t1ob5k59-1": [({
      isOpen
    }) => isOpen ? 'translateX(0)' : 'translateX(4rem)'],
    "t1ob5k59-2": [({
      isOpen
    }) => isOpen ? 'visible' : 'hidden'],
    "t1ob5k59-3": [({
      isOpen
    }) => isOpen ? 'translateX(0)' : 'translateX(-4rem)']
  }
});
const PrimaryNavTrayPanelLists = exports.PrimaryNavTrayPanelLists = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PrimaryNavTrayPanelLists",
  class: "pl-p1l4r46u",
  vars: {
    "p1l4r46u-0": [({
      items
    }) => items === 3 ? '2 3' : '1'],
    "p1l4r46u-1": [({
      items,
      images
    }) => {
      if (images === 2) {
        return 'span 4';
      }
      return items === 3 ? 'span 4' : 'span 3';
    }]
  }
});
const PrimaryNavTrayPanelFeatures = exports.PrimaryNavTrayPanelFeatures = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PrimaryNavTrayPanelFeatures",
  class: "pl-pouniei",
  vars: {
    "pouniei-0": [({
      hasImages
    }) => hasImages ? '1 1' : '0 1'],
    "pouniei-1": [({
      isOpen
    }) => isOpen ? '1' : '0']
  }
});
const Chevron = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Chevron",
  class: "pl-c10jhkes",
  vars: {
    "c10jhkes-0": [props => props.isOpen ? 'rotateX(180deg)' : 'rotateX(0deg)']
  }
});
const ButtonText = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "ButtonText",
  class: "pl-b1qxqzy9"
});

/**
 * Primary Nav Tray Menu Item component.
 *
 * @param {Object} props React props
 * @param {string} props._name Tracking name
 * @param {string} props.text Text string
 * @param {Object} props.primaryNavTray Panel
 * @param {boolean} props.isOpen Boolean for open/closed state
 * @param {boolean} props.isWrap Boolean for wrapped nav state
 * @param {function} props.setIsOpen Setter for panel open state
 * @param {function} props.setIsParentOpen Setter for parent open state
 * @param {number} props.index Index of Menu Item
 * @param {string} props.href Link used if no tray is provided
 * @param {boolean} props.invert Invert styles for dark navigation
 * @returns {React.ReactElement} Primary Nav Tray Menu Item
 * @public
 */
function PrimaryNavTrayMenuItem({
  text,
  primaryNavTray,
  isOpen,
  isWrap,
  setIsOpen,
  setIsParentOpen,
  index,
  href,
  invert,
  _name
}) {
  const backButton = (0, _react.useRef)(null);
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  function toggleMenu(siblings) {
    // Click collapsed FeatureMenuItem
    if (!siblings[index]) {
      setIsParentOpen(true);
      return siblings?.map((sibling, i) => i === index ? !sibling : false);
    }

    // Click expanded FeatureMenuItem in Tablet
    if (isWrap) {
      setIsParentOpen(true);
      return siblings;
    }

    // Click expanded FeatureMenuItem in Desktop
    setIsParentOpen(false);
    return siblings?.map(() => false);
  }
  function hasImages() {
    return primaryNavTray?.featuredImages && primaryNavTray?.featuredImages.length > 0;
  }
  return primaryNavTray ? /*#__PURE__*/_react.default.createElement(FeatureMenuItem, (0, _extends2.default)({
    isOpen: isOpen,
    "data-cy": "primary-nav-tray-menu-item"
  }, _patternLibraryUtils.tracking.create(_name, true, false), {
    onClick: () => setIsOpen(siblings => {
      return toggleMenu(siblings);
    })
  }), /*#__PURE__*/_react.default.createElement(FeatureMenuButton, {
    isOpen: isOpen,
    "aria-haspopup": "true"
  }, /*#__PURE__*/_react.default.createElement(ButtonText, null, text), width >= _patternLibraryUtils.size.mostCommon && /*#__PURE__*/_react.default.createElement(Chevron, {
    "data-cy": "chevron-item",
    isOpen: isOpen
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-down"
  }))), /*#__PURE__*/_react.default.createElement(LinkArrowWrapper, {
    isOpen: isOpen
  }, /*#__PURE__*/_react.default.createElement(LinkArrowComponent, {
    fill: _intentsConfig.default.ux.box.foregroundColor
  })), /*#__PURE__*/_react.default.createElement(TrayDropdown, {
    "data-partial": "light1",
    "data-cy": "tray-dropdown",
    isOpen: isOpen,
    onClick: e => !e.target.hasAttribute('href') && e.stopPropagation()
  }, /*#__PURE__*/_react.default.createElement(TrayDropdownBack, {
    "data-cy": "back-button",
    ref: backButton,
    onClick: () => setIsOpen(siblings => siblings.map(() => false))
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-left",
    fill: _intentsConfig.default.ux.box.foregroundColor
  })), /*#__PURE__*/_react.default.createElement(TrayContent, {
    "data-cy": "tray-content",
    isOpen: isOpen
  }, /*#__PURE__*/_react.default.createElement(PrimaryNavTrayPanelLists, {
    items: primaryNavTray?.primaryNavMenus.length,
    images: primaryNavTray?.featuredImages?.length
  }, primaryNavTray?.primaryNavMenus?.map(({
    menuTitle,
    menuItems,
    categoryText,
    categoryHref,
    categoryTrackingName,
    categoryHrefArrow
  }, i) => /*#__PURE__*/_react.default.createElement(_primaryNavTrayPanel.PrimaryNavTrayPanelList, {
    key: i,
    title: menuTitle,
    menuItems: menuItems,
    categoryHref: categoryHref,
    categoryText: categoryText,
    categoryTrackingName: categoryTrackingName,
    isOpen: isOpen,
    categoryHrefArrow: categoryHrefArrow
  }))), /*#__PURE__*/_react.default.createElement(PrimaryNavTrayPanelFeatures, {
    isOpen: isOpen,
    hasImages: hasImages()
  }, primaryNavTray.featuredImages && primaryNavTray.featuredImages.map(({
    id: featureId,
    image,
    text: featureText,
    href: featureHref,
    _name: featureName
  }, i) => /*#__PURE__*/_react.default.createElement(_primaryNavTrayFeature.PrimaryNavTrayFeature, {
    id: featureId,
    key: i,
    _name: featureName,
    image: image,
    text: featureText,
    href: featureHref
  })))))) : /*#__PURE__*/_react.default.createElement(FeatureMenuItem, {
    className: invert && 'inverted'
  }, /*#__PURE__*/_react.default.createElement(FeatureMenuLink, (0, _extends2.default)({
    href: href
  }, _patternLibraryUtils.tracking.create(_name, true, false)), text));
}
PrimaryNavTrayMenuItem.propTypes = {
  _name: _propTypes.default.string,
  text: _propTypes.default.string,
  primaryNavTray: _propTypes.default.shape({
    primaryNavMenus: _propTypes.default.arrayOf(_propTypes.default.shape({
      menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
        title: _propTypes.default.string
      })),
      menuTitle: _propTypes.default.string
    })),
    featuredImages: _propTypes.default.arrayOf(_propTypes.default.shape(_primaryNavTrayFeature.PrimaryNavTrayFeature.propTypes))
  }),
  isOpen: _propTypes.default.bool,
  isWrap: _propTypes.default.bool,
  setIsOpen: _propTypes.default.func,
  setIsParentOpen: _propTypes.default.func,
  index: _propTypes.default.number,
  href: _propTypes.default.string,
  invert: _propTypes.default.bool
};